/**
 * API Configuration
 * Centralized configuration for API endpoints
 * 
 * Environment variables (Vite):
 * - VITE_API_BASE_URL: Override API base URL
 * 
 * Auto-detection:
 * - Production: https://vaultapi.techpuram.com/api (when hostname includes techpuram.com)
 * - Development: http://localhost:8050/api (default)
 */

// Get API base URL from environment variable or auto-detect
export const getApiBaseUrl = () => {
	// Priority 1: Environment variable (set in .env.development or .env.production)
	if (import.meta.env.VITE_API_BASE_URL) {
		return import.meta.env.VITE_API_BASE_URL;
	}
	
	// Priority 2: Auto-detect based on hostname (fallback)
	const hostname = window.location.hostname;
	if (hostname === 'ivault.techpuram.com' || hostname.includes('techpuram.com')) {
		return 'https://vaultapi.techpuram.com/api';
	}
	
	// Priority 3: Default to localhost for development
	return 'http://localhost:8050/api';
};

// Export the API base URL
export const API_BASE_URL = getApiBaseUrl();

// Helper function to build full API URL
export const getApiUrl = (path = '') => {
	const baseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
	const apiPath = path.startsWith('/') ? path : `/${path}`;
	return `${baseUrl}${apiPath}`;
};

